/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import Collapse from '../Collapse';
import { vehicleContext } from '../VehicleProvider';
import showModule from '../../utils/showModule';
import RowItem from './components/RowItem';
import {
  Container,
  HeaderContainer,
  InnerContainer,
  CPOContainer,
  Model,
  H3,
  Column,
  RowContainer,
  ImportantRow,
  CarfaxContainer,
  CarfaxLogo,
  Cta,
  CtaContainer,
  ModelName,
  SkeletonWrapper,
  CarfaxTextLink,
} from './VehicleHistory.styles';
import { CARFAX_ICON } from '../../constants';

const VehicleHistory: React.FC = () => {
  const { vehicle, loading, market, oaddDealerId } = useContext(vehicleContext);
  // Temporarily log for testing
  console.log('🚀 Vehicle History Feature App ~ oaddDealerId:', oaddDealerId);
  const { t, i18n } = useTranslation();
  const lang = i18n.languages?.[0] || 'en';
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });

  const report = vehicle && vehicle?.vehicleHistoryReports;
  const warranty = vehicle && vehicle?.warrantyType;
  const electric = vehicle?.fuelType === 'hybrid' || vehicle?.fuelType === 'etron';
  const isUS = market === 'us' || market === 'usuc';
  const usCPO = isUS && warranty;
  const vehicleTypeReference = electric && !usCPO ? 'charging' : 'transmission';
  const oaddParam = oaddDealerId?.length ? `?partner_id=${oaddDealerId}` : '';

  const vehicleHistorySection = (
    <Container report={showModule(warranty)} data-testid="history-section-component">
      {(report || warranty) && (
        <HeaderContainer cpo={warranty} report={report}>
          <H3>{t('vehicleHistory.headline')}</H3>
          {warranty !== null && (
            <ImportantRow>
              {isUS ? <p>{t(`vehicleHistory.usSubHead`)}</p> : <p>{t('vehicleHistory.subhead')}</p>}
            </ImportantRow>
          )}

          <Model cpo={warranty} report={report}>
            {t('vehicleHistory.model')}:
            <ModelName data-vehicle-model-name={vehicle?.modelName}>
              {' '}
              {vehicle?.modelName}
            </ModelName>
          </Model>
        </HeaderContainer>
      )}
      <CPOContainer report={report}>
        {warranty !== null && (
          <RowContainer>
            <Column>
              <RowItem row="interior" />
              <RowItem row="exterior" />
              <RowItem row="engine" />
              <RowItem row="roadTest" />
            </Column>
            <Column>
              <RowItem row="tires" />
              <RowItem row="brakes" />
              <RowItem row={market === 'usuc' ? 'driverAssist' : 'electrical'} />
              <RowItem row={vehicleTypeReference} />
            </Column>
          </RowContainer>
        )}

        <InnerContainer report={report}>
          {/* {market !== 'usuc' && report !== null && (
            <CarfaxContainer
              target="_blank"
              href={report && report[0]?.url}
              report={report}
              cpo={warranty}
            >
              <CarfaxLogo src={CARFAX_ICON} alt="Carfax Report" />
              <CarfaxTextLink cpo={warranty}>{t('vehicleHistory.visitCarfax')}</CarfaxTextLink>
            </CarfaxContainer>
          )} */}

          {warranty !== null && (
            <CtaContainer>
              <>
                <Cta
                  href={
                    market === 'usuc'
                      ? `https://www.audiusa.com/us/web/${lang}/shopping-tools/certified-pre-owned.html${oaddParam}#nm-anchor594760089`
                      : `https://www.audi.ca/ca/web/${lang}/cpo/layer/Why-buy-certified.html`
                  }
                  target="_blank"
                >
                  {t('vehicleHistory.whybuy')}
                </Cta>
                <Cta
                  primary
                  href={
                    market === 'usuc'
                      ? `https://www.audiusa.com/us/web/${lang}/shopping-tools/certified-pre-owned.html${oaddParam}#faqs`
                      : `https://www.audi.ca/ca/web/${lang}/cpo/layer/faq.html`
                  }
                  target="_blank"
                >
                  {market === 'usuc' ? t('vehicleHistory.usfaqs') : t('vehicleHistory.faqs')}
                </Cta>
              </>
            </CtaContainer>
          )}
        </InnerContainer>
      </CPOContainer>
    </Container>
  );

  return vehicle && showModule(warranty) ? (
    isMobile ? (
      <Collapse heading={t('vehicleHistory.headline')}>{vehicleHistorySection}</Collapse>
    ) : (
      vehicleHistorySection
    )
  ) : loading ? (
    <Container report={showModule(warranty)} data-testid="skeleton-loader-component">
      <SkeletonWrapper>
        <Skeleton />
      </SkeletonWrapper>
    </Container>
  ) : null;
};

export default VehicleHistory;
